import { DATA_LOADING_STATES, METRIC_NAMES, SORT_DIRECTION } from '@config/Consts';

export default {
  metrics: {
    value: null,
    dataStatus: DATA_LOADING_STATES.NONE,
    lastTimeDataUpdated: null,
  },
  metricsTotal: {
    value: null,
    dataStatus: DATA_LOADING_STATES.NONE,
    lastTimeDataUpdated: null,
  },
  metricsOverdue: {
    value: null,
    dataStatus: DATA_LOADING_STATES.NONE,
    lastTimeDataUpdated: null,
  },
  sort: {
    columnName: METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
    direction: SORT_DIRECTION.DESCENDING,
  },
};
